// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Slider_slider__1oq2R {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 24px);\n  padding: 8px 8px 8px 16px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Slider/Slider.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;AAC3B","sourcesContent":[".slider {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 24px);\n  padding: 8px 8px 8px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider": "Slider_slider__1oq2R"
};
export default ___CSS_LOADER_EXPORT___;
